import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { IssueTrackingTool } from "@ea/shared_types/types";
import { moduleActions } from "./its.actions";

const initialState = {
  ...getDataReducerInitialState<IssueTrackingTool>(),
};

export type IstReducer = typeof initialState;

const dataReducer = createDataReducer<IssueTrackingTool>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
